import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';

import { DeliveryLayoutComponent } from './delivery-layout/delivery-layout.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { FullLayoutComponent } from './full-layout/full-layout.component';
import { DeliveryLockLayoutComponent } from './delivery-lock-layout/delivery-lock-layout.component';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
  imports: [ CommonModule, IonicModule, RouterModule, SharedModule],
  exports: [
    MainLayoutComponent,
    DeliveryLayoutComponent,
    DeliveryLockLayoutComponent,
    FullLayoutComponent,
  ],
  declarations: [
    MainLayoutComponent,
    DeliveryLayoutComponent,
    DeliveryLockLayoutComponent,
    FullLayoutComponent,
  ],
  providers: [],
})
export class LayoutsModule {}
